<template>

  <component :is="el" :label="label" :required="required">
    <i v-if="noForm">{{label}}&nbsp;</i>

    <el-select
      v-model="formData"
      :placeholder="placeholder"
      value-key="value"
      :size="size"
      :disabled="disabled"
      @change="updated">

      <el-option
        v-for="(item, index) in (!limited ? items : limited)"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>

    </el-select>

  </component>

</template>

<script>

export default {
  name: 'select-org',



  props: {

    label: {
      type: String,
      default: 'Organisation'
    },

    value: {
//      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'Telco'
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Array,
      default: null
    },

    isAdmin: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    selectCategory (list, cat = null) {
      let org = {}

      for (let i = 0; i < list.length; i++) {

        if (list[i].label.toLowerCase() === cat.toLowerCase()) {
          org = list[i].options
        }

      }

      return org
    },


    doLimits (lim, items) {

      this.limited = null

      if (this.isArray(lim) && this.isArray(items)) {
        this.limited = []

        for (let l = 0; l < lim.length; l++) {
          for (let i = 0; i < items.length; i++) {

            if (items[i].data.id === lim[l]) {
              this.limited.push(items[i])
            }

          } // for limit

        } // for items

        return this.limited
      } // if limit

      return items
    },


    updated (id) {
      let org = null

      for (let i = 0; i < this.items.length; i++) {

        if (this.items[i].value === id) {
          org = this.items[i]
          org.id = org.value
          org.name = org.label
          break
        }
      }

      this.$emit('input', this.fullObject ? org : id)
      this.$emit('change', this.fullObject ? org : id)
    }

  },


  watch: {

    limit: function (lim) {
      this.doLimits(lim, this.items)
    },

    type: function (type) {
      this.items = []
      this.items = this.selectCategory(this.getConfig().orgGroups, type)
    }

  },

  data () {
    return {
      formData: this.value,
      items: this.selectCategory(this.getConfig().orgGroups, this.type),
      limited: null,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  },

  created () {
    this.doLimits(this.limit, this.items)
//    console.log('select-org: type', this.type, 'disabled', this.disabled, 'el', this.el, 'items', this.items, 'limited', this.limited)
  }

}
</script>
